// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_fontawesome.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateHomeArchive from './routes/template-home-archive';
import templateCommunityArchive from './routes/template-community-archive';
import singleCommunity from './routes/single-community';
import archiveMap from './routes/archive-map';
import searchResults from './routes/search-results';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Move-in Ready Homes Archive
  templateHomeArchive,
  // Communities Archive
  templateCommunityArchive,
  // Communities Archive
  singleCommunity,
  // Map Archive JS
  archiveMap,
  // Search Results
  searchResults,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js